<template>
    <div class="d-flex justify-content-center m-12">
        <div class="spinner-border text-primary" style="width: 6rem; height: 6rem;" role="status">
        </div>
    </div>
</template>
